<template>
    <div class="col-md-12" style="height: 100%;">
        <template v-if="showFolderView">
            <div class="row" style="padding-top: 15px; padding-bottom: 5px;">
                <div class="col-md-6">
                    <h3 class="header">FORM I-983</h3>
                </div>
                <div class="col-md-6 text-right">
                    <ob-button type="primary" @click="onUploadClick" v-if="isHRManager">Upload Physically Signed I-983</ob-button>
                    <ob-button  type="secondary" v-if="!disableInitiateButton">Initiate <i aria-hidden="true" class="fa fa-chevron-down"></i></ob-button>
                    <ob-dropdown v-else  title="Initiate">
                        <ob-dropdown-list-item @click.native="onInitiatetudentEvaluation" >Initiate Student Evaluation</ob-dropdown-list-item>
                        <ob-dropdown-list-item @click.native="onMaterialChange" v-if="isHRManager || isSupervisor ">Initiate Material Change</ob-dropdown-list-item>
                    </ob-dropdown>
                </div>
            </div>
            <div class="row" style="height: calc(100% - 64px); position: relative; z-index: 0;">
                <div class="col-md-12" style="height: calc(106% - 15px);padding-right: 5px;padding-left: 0">
                    <ob-table :isRowClickable="true" @rowClick="handleRowClick" theme="light" fixed-body="100%" :table-header="tableHeader" :table-data="tableData" :config="config" ref="maintable">
                        <template slot="th">
                            <th><span class="cell-data">Status</span></th>
                            <th><span class="cell-data"></span></th>
                        </template>
                        <template v-for="(item, index) in tableData" :slot="`td${item[config.primaryKey]}${index}`">
                            <td :key="`status${item[config.primaryKey]}`">
                                <template v-if="item.Status == 'Completed'">
                                    <template v-if="item.IsInitiated"> <!-- Initiate Flow -->
                                        <span class="rcss-text-green1">
                                            <span style="font-weight: 600;">Completed and Signed</span>
                                            <span v-if="item.Type == 'Primary'" v-tooltip="`Form I-983 is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'MaterialChange'" v-tooltip="`Form I-983 (Material Change) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'Evaluation' && !item.Evaluation.IsFinalEvalution" v-tooltip="`Form I-983 (Student Evaluation) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'Evaluation' && item.Evaluation.IsFinalEvalution" v-tooltip="`Form I-983 (Final Student Evaluation) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                    </template>
                                    <template v-else> <!-- Upload Flow -->
                                        <span class="rcss-text-green1" v-if="isAllSectionsCompletedForUploadFlow(item)">
                                            <span style="font-weight: 600;">Completed and Signed</span>
                                            <span v-if="item.Type == 'Primary'" v-tooltip="`Form I-983 is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'MaterialChange'" v-tooltip="`Form I-983 (Material Change) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'Evaluation' && !item.Evaluation.IsFinalEvalution" v-tooltip="`Form I-983 (Student Evaluation) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'Evaluation' && item.Evaluation.IsFinalEvalution" v-tooltip="`Form I-983 (Final Student Evaluation) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                        <span class="rcss-text-red" v-else>
                                            <span style="font-weight: 600;">Incomplete</span>
                                            <span v-tooltip="`Completed and ${IsPhysically(item.SignatureType)} signed Form I-983 is uploaded but some of the details are yet to be completed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="item.IsInitiated && item.IsInitiateOnlySectionType && item.Type == 'Evaluation' && item.Evaluation.SectionStatus == 'Completed'  && item.Evaluation.SignedDocument != null">
                                        <span class="rcss-text-green1">
                                            <span style="font-weight: 600;">Completed and Signed</span>
                                            <span v-if="item.Type == 'Evaluation' && !item.Evaluation.IsFinalEvalution" v-tooltip="`Form I-983 (Student Evaluation) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'Evaluation' && item.Evaluation.IsFinalEvalution" v-tooltip="`Form I-983 (Final Student Evaluation) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                    </template>
                                     <template v-else-if="item.IsInitiated && item.IsInitiateOnlySectionType && item.Type == 'MaterialChange' && item.Employer.SectionStatus == 'Completed' && showCollapse('Employer',item) && !IsMultipleMaterialChange(item) && item.MaterialChange.SectionStatus == 'Completed'  && item.Employer.SignedDocument != null">
                                        <span class="rcss-text-green1">
                                            <span style="font-weight: 600;">Completed and Signed</span>
                                            <span v-if="item.Type == 'MaterialChange'" v-tooltip="`Form I-983 (Material Change) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                    </template>
                                    <template v-else-if="item.IsInitiated && item.IsInitiateOnlySectionType && item.Type == 'MaterialChange' && item.AssignedTraining.SectionStatus == 'Completed' && showCollapse('Training',item) && !IsMultipleMaterialChange(item) && item.MaterialChange.SectionStatus == 'Completed'  && item.AssignedTraining.SignedDocument != null">
                                        <span class="rcss-text-green1">
                                            <span style="font-weight: 600;">Completed and Signed</span>
                                            <span v-if="item.Type == 'MaterialChange'" v-tooltip="`Form I-983 (Material Change) is completed and ${IsPhysically(item.SignatureType)} signed`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                    </template>
                                    <template v-else-if="isStudentEvaluationPending(item)">
                                        <span class="rcss-text-warning" v-if="isHRManager || isSupervisor">
                                            <span style="font-weight: 600;">Pending from student</span>
                                            <span v-tooltip="'Student Evaluation is not submitted by the student yet.'"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                        <span class="rcss-text-warning" v-else style="font-weight: 600;">
                                            <i class="fa fa-warning"></i> Pending Evaluation
                                        </span>
                                    </template>
                                    <template v-else-if="isMaterialChangeInComplete(item)">
                                        <span class="rcss-text-warning">
                                            <span style="font-weight: 600;">Incomplete</span>
                                            <span v-tooltip="'Material Change details are incomplete.'"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                    </template>
                                    <template v-else-if="isPhysicalSignaturePending(item)">
                                        <span class="rcss-text-warning">
                                            <span style="font-weight: 600;">{{ handleFolderStatus(item.SignatureType) }}</span>
                                            <span v-if="item.Type == 'Primary'" v-tooltip="`${IsPhysically(item.SignatureType)} signature is pending for this completed Form I-983.`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'MaterialChange'" v-tooltip="`${IsPhysically(item.SignatureType)} signature is pending for the Material Change in this Form I-983.`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                            <span v-else-if="item.Type == 'Evaluation'" v-tooltip="`${IsPhysically(item.SignatureType)} signature is pending for the Student Evaluation in this Form I-983`"><i class="fa fa-info-circle rcss-text-info-blue"></i></span>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span class="rcss-text-warning">
                                            <span style="font-weight: 600;">Pending</span>
                                        </span>
                                    </template>
                                </template>
                            </td>
                            <td :key="`actions${item[config.primaryKey]}`">
                                <template v-if="item.IsInitiateOnlySectionType   && item.IsInitiated">
                                    <template v-if="item.Type == 'Evaluation' && item.Evaluation.SectionStatus == 'Completed'">
                                        <ob-dropdown title="Actions" class="js-stop-propagate-class">
                                            <ob-dropdown-list-item @click.native="ViewOrDownloadDocument(item.Id, 'Evaluation', false)">Preview Complete Form</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'Evaluation', false, item.SignedDocument)">View Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'Evaluation', true, item.SignedDocument)">Download Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item @click.native="selectedFileIndex = index;onShare(item.Id, 'Evaluation', false, item.SignedDocument)">Share Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="showDeleteAction(item.CreatedBy.Email)" @click.native="confirmDeleteForm(item.Id)">Delete Complete Form</ob-dropdown-list-item>
                                        </ob-dropdown>
                                    </template>
                                    <template v-else-if="item.Type == 'MaterialChange' && item.Employer.SectionStatus == 'Completed'">
                                        <ob-dropdown title="Actions" class="js-stop-propagate-class">
                                            <ob-dropdown-list-item @click.native="ViewOrDownloadDocument(item.Id, 'Employer', false)">Preview Complete Form</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'Employer', false, item.SignedDocument)">View Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'Employer', true, item.SignedDocument)">Download Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item @click.native="selectedFileIndex = index;onShare(item.Id, 'Employer', false, item.SignedDocument)">Share Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="showDeleteAction(item.CreatedBy.Email)" @click.native="confirmDeleteForm(item.Id)">Delete Complete Form</ob-dropdown-list-item>
                                        </ob-dropdown>
                                    </template>
                                     <template v-else-if="item.Type == 'MaterialChange' && item.AssignedTraining.SectionStatus == 'Completed'">
                                        <ob-dropdown title="Actions" class="js-stop-propagate-class">
                                            <ob-dropdown-list-item @click.native="ViewOrDownloadDocument(item.Id, 'AssignedTraining', false)">Preview Complete Form</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.AssignedTraining.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'AssignedTraining', false, item.AssignedTraining.SignedDocument)">View Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.AssignedTraining.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'AssignedTraining', true, item.AssignedTraining.SignedDocument)">Download Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item @click.native="selectedFileIndex = index;onShare(item.Id, 'AssignedTraining', false, item.AssignedTraining.SignedDocument)">Share Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="showDeleteAction(item.CreatedBy.Email)" @click.native="confirmDeleteForm(item.Id)">Delete Complete Form</ob-dropdown-list-item>
                                        </ob-dropdown>
                                    </template>
                                    <template v-else>
                                            <ob-button style="width: 85px;padding: 6px 6px;" v-if="showDeleteAction(item.CreatedBy.Email)" type="secondary"  class="js-stop-propagate-class" @click.native="confirmDeleteForm(item.Id)">Delete Form</ob-button>
                                            <div v-else style="min-width: 85px;">-</div>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="item.Status == 'Completed' || isPhysicalSignaturePending(item)">
                                        <ob-dropdown title="Actions" class="js-stop-propagate-class">
                                            <ob-dropdown-list-item v-if="item.IsInitiated" @click.native="ViewOrDownloadDocument(item.Id, 'CompleteForm', false)">Preview Complete Form</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'CompleteForm', false, item.SignedDocument)">View Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="item.SignedDocument != null" @click.native="ViewOrDownloadDocument(item.Id, 'CompleteForm', true, item.SignedDocument)">Download Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item @click.native="selectedFileIndex = index;onShare(item.Id, 'CompleteForm', false, item.SignedDocument)">Share Complete Document</ob-dropdown-list-item>
                                            <ob-dropdown-list-item v-if="showDeleteAction(item.CreatedBy.Email)" @click.native="confirmDeleteForm(item.Id)">Delete Complete Form</ob-dropdown-list-item>
                                        </ob-dropdown>
                                    </template>
                                    <template v-else>
                                        <ob-button style="width: 85px;padding: 6px 6px;" v-if="showDeleteAction(item.CreatedBy.Email)" type="secondary"  class="js-stop-propagate-class" @click="confirmDeleteForm(item.Id)">Delete Form</ob-button>
                                        <div v-else style="min-width: 85px;">-</div>
                                    </template>
                                </template>
                            </td>
                        </template>
                    </ob-table>
                </div>
            </div>
        </template>
        <template v-else>
            <file-view :content.sync="selectedFile" @deleteForm="confirmDeleteForm" @onBackClick="showFolderView = true"></file-view>
        </template>

        <share-I983-popup :sharePopup.sync="showSharePopup"  :shareDetails.sync="shareDetails"> </share-I983-popup>
        <initiate-student-evalution :openModal.sync="showEvalution" :isupdate='false' :previousData="previousData" @initiated="$emit('initiated')"></initiate-student-evalution>
        <initiate-material-change-popup :openModal.sync="showMaterialChange" :updatecontent="previousData" :content="previousData" @initiated="$emit('initiated')"></initiate-material-change-popup>
        <uploadI983-Popup  v-if="showUploadPopup" :openModal.sync="showUploadPopup" @initiated="$emit('initiated')" :previousData="previousData"></uploadI983-Popup>
    </div>
</template>
<script>
import utils from "Vue/Core/utils.js";
import FileView from "./FileView.vue";
import ShareI983Popup from './ShareI983Popup.vue';
import InitiateStudentEvalution from './InitiateStudentEvalution.vue';
import InitiateMaterialChangePopup from './InitiateMaterialChangePopup.vue';
import UploadI983Popup from './UploadI983Popup.vue';

export default {
    props: ["list"],
    data() {
        return {
            empData: '',
            IsDocument:false,
            showEvalution:false,
            showMaterialChange:false,
            showUploadPopup:false,
            previousData:'',
            showSharePopup : false,
            showFolderView: true,
            selectedFileIndex: 0,
            sectionType:'',
            docURL:'',
            config: {
                primaryKey: "Id",
                fixedCols: {
                    left: 0,
                    right: 0
                }
            },
            tableHeader: [
                {
                    key: "Title",
                    name: "Title",
                     tdstyle: 'max-width: 220px;min-width: 220px',
                    transform: (o) => {
                        let title = this._getTitleByType(o.Type, o);

                        const template = `
                            <div>
                                <i class="fa fa-folder" style="color: #8CC4EF;font-size: 26px;display: inline-block;margin-right: 5px;"></i>
                                <span style="display: inline-block;line-height: 26px;font-size: 13px;transform: translateY(-5px);">${title}   <br> <span style="font-size: 12px;margin-top: -8px;display: block;"> Ink Signature</span></span>
                            </div>
                        `;
                        
                        const electronicTemplate = `
                            <div>
                                <i class="fa fa-folder" style="color: #8CC4EF;font-size: 26px;display: inline-block;margin-right: 5px;transform: translateY(-6px);"></i>
                                <span style="display: inline-block;line-height: 23px;font-size: 13px;transform: translateY(-3px);">${title}  <br> <span style="font-size: 12px;margin-top: -8px;display: block;"> Electronic Signature</span> </span>
                            </div>
                        `;                        
                        return  o.SignatureType == "Electronic" ? electronicTemplate : template;
                    }
                },
                {
                    tdstyle: 'max-width: 160px;min-width: 160px',
                    key: "InitiatedDate",
                    name: "Initiated/Uploaded Date",
                    transform: (o) => {
                        return o.CreatedDate
                    }
                },
                {
                    tdstyle: 'max-width: 160px;min-width: 160px',
                    key: "CompletedDate",
                    name: "Completed/Signed Date",
                    transform: (o) => {
                        if(o.IsInitiateOnlySectionType  && o.IsInitiated && !this.IsMultipleMaterialChange(o))
                        {
                            if(o.Type == 'Evaluation' && o.Evaluation.SectionStatus == 'Completed' )
                            {
                                return o.Evaluation.SignedDocument && o.Evaluation.SignedDocument.SignedDateString ? o.Evaluation.SignedDocument.SignedDateString : '-';
                            }
                           else if(o.Type == 'MaterialChange' && o.Employer.SectionStatus == 'Completed' && this.showCollapse('Employer',o))
                            {
                                return o.Employer.SignedDocument && o.Employer.SignedDocument.SignedDateString ? o.Employer.SignedDocument.SignedDateString : '-';
                            }
                            else if(o.Type == 'MaterialChange' && o.AssignedTraining.SectionStatus == 'Completed' && this.showCollapse('Training',o))
                            {
                                return o.AssignedTraining.SignedDocument && o.AssignedTraining.SignedDocument.SignedDateString ? o.AssignedTraining.SignedDocument.SignedDateString : '-';
                            }
                        }
                        return o.SignedDocument && o.SignedDocument.SignedDateString ? o.SignedDocument.SignedDateString : '-';
                    }
                }
            ],
        }
    },
    computed: {
        clonedList: {
            get() {
                return this.list;
            },
            set(v) {
                this.$emit('update:list', v);
            }
        },
        tableData() {
            return this.clonedList;
        },
        selectedFile: {
            get() {
                return this.clonedList[this.selectedFileIndex];
            },
            set(v) {
                Vue.set(this.clonedList, this.selectedFileIndex, v);
            }
        },
        shareDetails()
        {
            if(this.docURL != null && this.docURL != '')
            {
                 var shareDetails = {
                        Id:this.selectedFile.Id,
                        EmployeeId:this.selectedFile.Employee.EmployeeId,
                        StudentName : this.selectedFile.Employee.Name,
                        StudentEmail :  this.selectedFile.Employee.Email,
                        EmployerName : this._getEmployerName(),
                        EmployerEmail :  this._getEmployerEmail(),
                        DSOName : this.selectedFile.Employee.DSO,
                        DSOMail : this.selectedFile.Employee.DSOMail,
                        Sectiontype : this.sectionType,
                        DocUrl : this.docURL,
                        Type: this.selectedFile.Type,
                        IsDocument : this.IsDocument
                    }
                 return shareDetails
            }
        },
        EmployeeId() {
            return this.$parent.EmployeeId;
        },
        StudentName() {
            return this.$parent.StudentName;
        },
        IsFinalEvaluationDone() {
            return this.$parent.IsFinalEvaluationDone;
        },
        LoggedInUserEmail() {
            return this.loggedInUserObj.email ? this.loggedInUserObj.email : this.loggedInUserObj.Email;
        },
        isSupervisor(){
            if(this.$parent.isSupervisor)
             return true
             else return false

        },
        disableInitiateButton(){
            return true;
         },
    },
    components: {
        'file-view': FileView,
        'share-I983-popup': ShareI983Popup,
        'initiate-student-evalution': InitiateStudentEvalution,
        'initiate-material-change-popup': InitiateMaterialChangePopup,
        'uploadI983-Popup': UploadI983Popup,
    },
    mounted() {
        setTimeout(() => {
            this.$refs.maintable.initCompile();
        }, 350);
    },
    created(){
        this.getEmpDetails()
    },
    methods: {
        handleFolderStatus(val) {
            if( val == 'Electronic') {
                return 'Pending'
            }else {
                return 'Pending Physical Signature'
            }
        }, 
        IsPhysically(signatureType)
        {
            if(signatureType == 'Electronic')
            {
                return 'Pending' ;
            }
            else
            {
                return 'physically'
            }
        },
        IsMultipleMaterialChange(content)
        {
            if(content.Type == 'MaterialChange' && content.IsInitiateOnlySectionType && content.IsInitiated)
            {
                if(content.MaterialChange != null && content.MaterialChange.MaterialChangeType != null)
                {
                    if((content.MaterialChange.MaterialChangeType.indexOf("ChangeOfEmployerIdentificationNumber") > -1 || content.MaterialChange.MaterialChangeType.indexOf("ReductionInStudentCompensation") > -1 || content.MaterialChange.MaterialChangeType.indexOf("DecreaseInHoursPerweek") > -1 || content.MaterialChange.MaterialChangeType.indexOf("Others") > -1)
                        &&(content.MaterialChange.MaterialChangeType.indexOf("ChangesCommitmentsOrObjectives") > -1 || content.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1 || content.MaterialChange.MaterialChangeType.indexOf("ChangeInEmployerSite") > -1 || content.MaterialChange.MaterialChangeType.indexOf("Others") > -1))
                    {
                        return true;
                    }
                }
            }
            return false;
        },
        showCollapse(type,content)
        { 
            if(content.IsInitiateOnlySectionType && content.IsInitiated)
            {
                if(content.Type == 'Evaluation')
                {
                    return false
                }
                else if(content.Type == 'MaterialChange')
                {
                    if(type == 'Employer' && (content.MaterialChange.MaterialChangeType.indexOf("ChangeOfEmployerIdentificationNumber") > -1 || content.MaterialChange.MaterialChangeType.indexOf("ReductionInStudentCompensation") > -1 || content.MaterialChange.MaterialChangeType.indexOf("DecreaseInHoursPerweek") > -1 || content.MaterialChange.MaterialChangeType.indexOf("Others") > -1))
                    {
                        return true
                    }
                    if(type == 'Training' && (content.MaterialChange.MaterialChangeType.indexOf("ChangesCommitmentsOrObjectives") > -1 || content.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1 || content.MaterialChange.MaterialChangeType.indexOf("ChangeInEmployerSite") > -1 || content.MaterialChange.MaterialChangeType.indexOf("Others") > -1))
                    {
                        return true
                    }
                    return false
                }
            return false;
            }
            else if(!content.IsInitiated)
            {
                return false;
            }
            return true
        },
        getEmpDetails(){
            //  this.leftLoader = true
              this.$loading({});
                ajax.get(`/Employee/${loggedInUserObj.empId}/BasicInfo`, {}, (res) => {
                    if(res.data.State == true){
                            this.empData = res.data.Employee
                            console.log("this.empData",this.empData)
                            this.$loading({}).close();
                            // this.consultantDetails = res.data.Employee
                            //this.leftLoader = false
                    }
                    // else{
                    //         this.leftLoader = false
                    //         this.ESSEnableDisable(res)
                    // }
                })
        },
        _getEmployerName() {
            let selectedFile = this.selectedFile;
            let CreatedBy  = this._getCreatedByObj(selectedFile);
            if(CreatedBy) {
                return CreatedBy && CreatedBy.FirstName ? CreatedBy.FirstName + ' ' + CreatedBy.LastName : '';
            } else {
                return '';
            }
        },
        _getEmployerEmail()
        {
            let selectedFile = this.selectedFile;
            let CreatedBy  = this._getCreatedByObj(selectedFile);
            if(CreatedBy) {
                return CreatedBy && CreatedBy.Email ? CreatedBy.Email : '';
            } else {
                return '';
            }
        },
        _getCreatedByObj(selectedFile) {
            if(selectedFile && selectedFile.CreatedBy && selectedFile.CreatedBy.CurrentRole) {
                if(selectedFile.CreatedBy.CurrentRole == "HRManager") {
                    return selectedFile.CreatedBy;
                } else {
                    let index = this._findHRCreatedRecord();
                    if(index != -1) {
                        return this.list[index].CreatedBy;
                    } else {
                        return null;
                    }
                }
            } else {
                return null;
            }
        },
        _findHRCreatedRecord() {
            return __.findIndex(this.list, function(o) {
                return o.CreatedBy && o.CreatedBy.CurrentRole == "HRManager";
            });
        },
        isAllSectionsCompletedForUploadFlow(item) {
            return (!this.isSection12Pending(item) && !this.isSection5Pending(item) && !this.isEmployerPending(item)) || item.Status == "Completed";
        },
        showDeleteAction(createdByEmail) {
            let loggedInUserEmail = this.LoggedInUserEmail;
            return this.isHRManager || loggedInUserEmail == createdByEmail;
        },
        _getTitleByType(type, item) {
            let title = type;

            if(type == 'Primary') {
                title = 'Form I-983 (Primary)';
            } else if(type == 'MaterialChange') {
                title = 'Form I-983 (Material Change)';
            } else if(type == 'Evaluation') {
                title = 'Student Evaluation';
                if(item.Evaluation && item.Evaluation.IsFinalEvalution) {
                    title = 'Student Evaluation (Final Evaluation)';
                }
            }

            return title;
        },
        isSection12Pending(item) {
            return item.Employee.SectionStatus != 'Completed';
        },
         isSection5Pending(item) {
            return item.AssignedTraining.SectionStatus != 'Completed' || item.AssignedTraining.Training == null || item.AssignedTraining.Training.Title == null;
        },
        isEmployerPending(item) {
            return item.Employer.SectionStatus != 'Completed';
        },
        isPhysicalSignaturePending(item) {
            if(item.IsInitiated) { // Initiate Flow
               if(item.IsInitiateOnlySectionType)
                {
                    if(item.Type == 'MaterialChange' && (item.MaterialChange.MaterialChangeType.indexOf("ChangeOfEmployerIdentificationNumber") > -1 || item.MaterialChange.MaterialChangeType.indexOf("ReductionInStudentCompensation") > -1 || item.MaterialChange.MaterialChangeType.indexOf("DecreaseInHoursPerweek") > -1 || item.MaterialChange.MaterialChangeType.indexOf("Others") > -1 || item.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1 ))
                    {
                        return item.Employer.SignedDocument == null;
                    }
                    if(item.Type == 'MaterialChange' && (item.MaterialChange.MaterialChangeType.indexOf("ChangesCommitmentsOrObjectives") > -1 || item.MaterialChange.MaterialChangeType.indexOf("PeriodicEvaluationFromTheUniversity") > -1 || item.MaterialChange.MaterialChangeType.indexOf("ChangeInEmployerSite") > -1 || item.MaterialChange.MaterialChangeType.indexOf("Others") > -1))
                    {
                        return item.AssignedTraining.Training != null && item.AssignedTraining.Training.Title != null && item.AssignedTraining.Training.Title != '' && item.AssignedTraining.signedDocument == null
                    }
                    return item.SignedDocument == null;
                }
                if(item.Type == 'Evaluation') {
                    return !this.isStudentEvaluationPending(item) && !this.isSection12Pending(item) && !this.isSection5Pending(item) && !this.isEmployerPending(item) && item.SignedDocument == null;
                }
                return !this.isSection12Pending(item) && !this.isSection5Pending(item) && !this.isEmployerPending(item) && item.SignedDocument == null;
            } else { // Upload Flow
                return item.SignedDocument == null && !this.isStudentEvaluationPending(item) && !this.isMaterialChangeInComplete(item);
            }
        },
        isStudentEvaluationPending(item) {
            return item.Type == 'Evaluation' && item.Evaluation.SectionStatus == 'PendingFromStudent';
        },
        isMaterialChangeInComplete(item) {
            return item.Type == 'MaterialChange' && item.MaterialChange.SectionStatus == 'InComplete';
        },
        handleRowClick(e, item) {
            if(utils.findAncestor(e.target, 'js-stop-propagate-class') === null) {
                this.selectedFileIndex = this.clonedList.findIndex(c => c.Id == item.Id);
                this.showFolderView = false;
            }
        },
        ViewOrDownloadDocument(id, sectionType, isDownload, signedDocument) {

            if(signedDocument == null || signedDocument.DocumentUrl == null){

                this.$loading({loadingText: 'Please wait...'});
                ajax.get(`/I983/${id}/Generate?sectionType=${sectionType}`, {}, (res) => {
                    if(res.data.State === true) {
                        if(isDownload === true) {
                            utils.downloadSingleDoc(res.data.I983DocUrl)
                            //window.open(utils.getFileDownloadLink(res.data.I983DocUrl), '_blank');
                        } else if(isDownload === false){
                              utils.previewSingleDoc(res.data.I983DocUrl)
                            //window.open(utils.getFilePreviewLink(res.data.I983DocUrl), '_blank');
                        }
                        else{
                            this.docURL = res.data.I983DocUrl
                            this.showSharePopup = true;
                        }
                    } else {
                        this.ESSEnableDisable(res)
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        })
                    }

                    this.$loading({}).close();
                });
            }
            else{
                var signedDocumentUrl = signedDocument.DocumentUrl;
                if(isDownload === true) {
                    utils.downloadSingleDoc(signedDocumentUrl)
                    //window.open(utils.getFileDownloadLink(signedDocumentUrl), '_blank');
                } else if(isDownload === false){
                    utils.previewSingleDoc(signedDocumentUrl)
                    //window.open(utils.getFilePreviewLink(signedDocumentUrl), '_blank');

                }
                else{
                    this.docURL = signedDocumentUrl
                    this.showSharePopup = true;
                }
            }
        },
        confirmDeleteForm(id) {
            this.$alert2("Are you sure you want to delete ?", "Alert", {
                type: "confirm",
                yesButtonText: "Yes",
                noButtonText: "No",
                callback: (action) => {
                    if(action === true) {
                        this.deleteForm(id);
                    }
                }
            });
        },
        deleteForm(id) {
            this.$loading({});
            ajax.put(`/I983/${id}/Delete`, {}, (res) => {
                this.$loading({}).close();
                if(res.data.State === true) {
                    this.$message({
                        type: 'success',
                        message: 'Record deleted successfully!'
                    });

                    // If the user deletes from file view
                    // on delete - navigate to folder view
                    this.showFolderView = true;

                    this.$emit('formDeleted', id);
                }
                else
                    this.ESSEnableDisable(res)
            });
        },
        onShare(id, SectionType,isdocument, signedDocument) {
               this.IsDocument = isdocument;
               this.sectionType = SectionType;
               if(isdocument)
               {
                    if(this.sectionType == 'SignedForm')
                    {
                        this.docURL = this.selectedFile.SignedDocument.DocumentUrl;
                        this.showSharePopup = true;
                    }
                    else if(this.sectionType == 'Evaluation')
                    {
                        this.docURL = this.selectedFile.Evaluation.SignedDocument.DocumentUrl;
                        this.showSharePopup = true;
                    }
                    else if(this.sectionType == 'Student')
                    {
                        this.docURL = this.selectedFile.Employee.SignedDocument.DocumentUrl;
                        this.showSharePopup = true;
                    }
                    else if(this.sectionType == 'Employer')
                    {
                        this.docURL = this.selectedFile.Employer.SignedDocument.DocumentUrl;
                        this.showSharePopup = true;
                    }
                    else if(this.sectionType == 'AssignedTraining')
                    {
                        this.docURL = this.selectedFile.AssignedTraining.SignedDocument.DocumentUrl;
                        this.showSharePopup = true;
                    }
               }
               else{
                     this.ViewOrDownloadDocument(id ,SectionType , 'share', signedDocument)
               }
        },
        insertSharedLogToStore(params)
        {
            let email = this.loggedInUserObj.email ? this.loggedInUserObj.email : this.loggedInUserObj.Email;
            var sharedTo = {
                Name : params.RecipientName,
                Email : params.EmailId
            }
            var sharedLog = {
                CreatedBy : {
                    Email : email
                },
                SharedTo : sharedTo,
                SectionType : params.SectionType,
                RecipientType : params.RecipientType,
                CreatedDate: moment().format('MM/DD/YYYY')
            }
            if(params.SectionType == 'Student' && params.IsDocument)
            {
                  params.SectionType = 'I983Student'
            }
            else if(params.SectionType == 'Employer' && params.IsDocument)
            {
                 params.SectionType = 'I983Employer'
            }
            else if(params.SectionType == 'Evaluation' && params.IsDocument)
            {
                params.SectionType = 'I983Evaluation'
            }
            else if(params.SectionType == 'AssignedTraining' && params.IsDocument)
            {
                params.SectionType = 'I983AssignedTraining'
            }

            if(params.SectionType == 'CompleteForm' || params.SectionType == 'SignedForm'
             || params.SectionType == 'I983Student' ||  params.SectionType == 'I983Employer'
             ||   params.SectionType == 'I983Evaluation' ||  params.SectionType == 'I983AssignedTraining'

            ) {
                this._pushLogsBySectionType(params.SectionType, 'SharedLog', sharedLog);
            } else {
                this._pushLogsBySectionType(params.SectionType, 'SharedLogs', sharedLog);
            }
        },
        insertModifiedLogToStore(SectionType) {
            // Workaround For ESS
            // Since in ESS the 'name' and 'email' are in lowercase
            let Name = this.loggedInUserObj.name ? this.loggedInUserObj.name : this.loggedInUserObj.Name;
            let Email = this.loggedInUserObj.email ? this.loggedInUserObj.email : this.loggedInUserObj.Email;

            let nameArr = Name.split(' ');
            let FirstName = '';
            let LastName = '';
            if(nameArr.length == 2) {
                FirstName = nameArr[0];
                LastName = nameArr[1];
            } else {
                FirstName = Name;
            }

            let log = {
                ModifiedBy: {
                    FirstName: FirstName,
                    LastName: LastName,
                    Email: Email
                },
                Modifieddate: moment().format('MM/DD/YYYY')
            };

            if(SectionType == 'CompleteForm') {
                this._pushLogsBySectionType(SectionType, 'ModifiedLog', log);
            } else {
                this._pushLogsBySectionType(SectionType, 'ModifiedLogs', log);
            }
        },
        _pushLogsBySectionType(SectionType, LogType, Log) {
            if(LogType) {
                if(SectionType == "SignedForm") {
                    this.selectedFile.SignedDocument[LogType] ? this.selectedFile.SignedDocument[LogType].unshift(Log) : this.selectedFile.SignedDocument[LogType] = [Log];
                } else if(SectionType == "Employer") {
                    this.selectedFile.Employer[LogType] ? this.selectedFile.Employer[LogType].unshift(Log) : this.selectedFile.Employer[LogType] = [Log];
                } else if(SectionType == "Student") {
                    this.selectedFile.Employee[LogType] ? this.selectedFile.Employee[LogType].unshift(Log) : this.selectedFile.Employee[LogType] = [Log];
                } else if(SectionType == "AssignedTraining") {
                    this.selectedFile.AssignedTraining[LogType] ? this.selectedFile.AssignedTraining[LogType].unshift(Log) : this.selectedFile.AssignedTraining[LogType] = [Log];
                } else if(SectionType == "CompleteForm") {
                    this.selectedFile[LogType] ? this.selectedFile[LogType].unshift(Log) : this.selectedFile[LogType] = [Log];
                }
                else if(SectionType == "Evaluation") {
                    this.selectedFile.Evaluation[LogType] ? this.selectedFile.Evaluation[LogType].unshift(Log) : this.selectedFile.Evaluation[LogType] = [Log];
                }else if(SectionType == "MaterialChange") {
                    this.selectedFile.MaterialChange[LogType] ? this.selectedFile.MaterialChange[LogType].unshift(Log) : this.selectedFile.MaterialChange[LogType] = [Log];
                }
    
                else if(SectionType == "I983Evaluation") {
                    this.selectedFile.Evaluation.SignedDocument[LogType] ? this.selectedFile.Evaluation.SignedDocument[LogType].unshift(Log) : this.selectedFile.Evaluation.SignedDocument[LogType] = [Log];
                }else if(SectionType == "I983Student") {
                    this.selectedFile.Employee.SignedDocument[LogType] ? this.selectedFile.Employee.SignedDocument[LogType].unshift(Log) : this.selectedFile.Employee.SignedDocument[LogType] = [Log];
                }else if(SectionType == "I983Employer") {
                    this.selectedFile.Employer.SignedDocument[LogType] ? this.selectedFile.Employer.SignedDocument[LogType].unshift(Log) : this.selectedFile.Employer.SignedDocument[LogType] = [Log];
                }else if(SectionType == "I983AssignedTraining") {
                    this.selectedFile.AssignedTraining.SignedDocument[LogType] ? this.selectedFile.AssignedTraining.SignedDocument[LogType].unshift(Log) : this.selectedFile.AssignedTraining.SignedDocument[LogType] = [Log];
                }
            }

        },
        onInitiatetudentEvaluation()
        {
           this.previousData =  this.tableData[0]
           this.showEvalution = true
        },
        onMaterialChange()
        {
           this.previousData =  this.tableData[0]
           this.showMaterialChange = true
        },
        onUploadClick()
        {
           this.previousData =  this.tableData[0]
           this.showUploadPopup = true
        }

    }
}
</script>
<style lang="scss" scoped>
.header{
    margin: 0;
    display: inline-block;
    font-weight: 700;
    color: #143361;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/FolderList.vue